import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import { Box, ThemeProvider } from '@mui/material';
import getTheme from '../theme/theme';
import { BASEURL } from "../constants/Common"


interface LogoutProps {
  onLogout: () => void;
}

const Logout: React.FC<LogoutProps> = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    let response; // Define response variable outside try block

    try {
      const accessToken = localStorage.getItem('token');
      if (accessToken) {
        response = await axios.post(
          //         'http://localhost:8000/logout/',
          BASEURL + '/logout/', {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      }

      localStorage.clear();

      onLogout();
      navigate('/');
      //   window.location.reload();
      if (response && response.status === 205) {
        toast.success('User logout successful');
      }
    }
    catch (error) {
      console.error('Error during logout:', error);
      if (axios.isAxiosError(error)) {
        if (error.response && error.response.status === 401) {
          toast.success('Session expired. Please log in again.');
          navigate('/login');
        } else {
          toast.error('Failed to logout');
        }
      } else {
        toast.error('An unexpected error occurred.');
      }
    }
  };


  return (
    <ThemeProvider theme={getTheme()}>
      <Box>
        <Button variant='contained' onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </ThemeProvider>
  );
};

export default Logout;
